import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import { connect } from 'react-redux'

import {
	resendActivation,
	openModal
} from 'state/actions'

class ValidationAlert extends Component {
	state = {
		hasResent: false
	}

	doResend = _ => {
		if(!this.state.hasResent){
			this.setState({
				hasResent: true
			})

			const {
				resendActivation,
				userData
			} = this.props

			resendActivation(userData)

			setTimeout(_ => {
				this.setState({
					hasResent: false
				})
			},5000)
		}
	}

	openBilling = _ => {
		this.props.openModal('upgrade', 'account')
	}

	getCopy = _ => {
		const {
			reason
		} = this.props

		const {
			hasResent
		} = this.state

		const copy = {}

		if(reason == 'email'){
			copy.title = "You'll need to confirm your email, when you've got a sec."
			copy.buttonLabel = hasResent ? 'Confirmation re-sent!' : 'Re-send confirmation'
			copy.icon = hasResent ? 'check' : 'fe-mail',
			copy.callback = this.doResend
		}else{
			copy.title = `Your Hassl trial ends in ${reason} days`
			copy.buttonLabel = 'Enter billing details'
			copy.icon = 'fe-credit-card'
			copy.callback = this.openBilling
		}

		return copy
	}

	render() {
		const copy = this.getCopy()

		return (
			<div className="validation-alert">
				<Icon name="bullhorn" />
				<span>
					{ copy.title }
					<button onClick={copy.callback}>
						<Icon name={copy.icon} />
						{ copy.buttonLabel }
					</button>
				</span>
			</div>
		)
	}
}

export default connect(null, {
	resendActivation,
	openModal
})(ValidationAlert)


// WEBPACK FOOTER //
// ./src/components/validation-alert/validation-alert.jsx